import { useEffect, useState } from "react";
import Api from "../../../../services/Api";
import Functions from "../../../../services/Functions";
import PieGraph from "../../../general/PieGraph";
import styles from "./InitialPageL2.module.css";
import LeafletMap from "./maps/LeafletMap";
import { InitialPageStore } from "./InitialPageStore";

function InitialPageL2({ distrito, onDistrictMapChange }) {
  const [imoveisDistritoData, setImoveisDistritoData] = useState(null);

  const setImovelImage = InitialPageStore((state) => state.setImovelImage);

  useEffect(() => {
    Api.getImoveisPorDistrito().then((value) => {
      if (value && Array.isArray(value.labels) && Array.isArray(value.data)) {
        const data = Functions.buildPieGraphParams(value.labels, value.data);
        setImoveisDistritoData(data);
      } else {
        console.warn("Dados inválidos recebidos da API:", value);
      }
      // termina o loading mesmo se a API falhar
    });
  }, []);

  return (
    <div className={styles.initialPageL2}>
      <LeafletMap
        distrito={distrito}
        onDistrictMapChange={onDistrictMapChange}
      />

      <div className={styles.pieGraph}>
        {imoveisDistritoData && (
          <PieGraph
            text="IMÓVEIS CADASTRADOS POR DISTRITO"
            data={imoveisDistritoData}
            onImageReady={setImovelImage}
          />
        )}
      </div>
    </div>
  );
}

export default InitialPageL2;
